import { getToken } from "@ctsu/loader";

// This function makes the fetch request and returns the raw response
async function makeRawRequest(url, method, body, auth, header = new Headers()) {
  const token = getToken();
  header.append("Content-Type", "application/json");

  if (auth) {
    header.append("Authorization", `Bearer ${token}`);
  } else {
    header.append("appName", process.env.REACT_APP_NAME);
  }

  const params = {
    crossDomain: !auth,
    withCredentials: !auth,
    credentials: "include",
    headers: header
  };
  if (auth) {
    delete params.credentials;
  }

  if (body && body.abortSignal) {
    params.signal = body.abortSignal;
    delete body.abortSignal;
  }

  if (body) {
    params.body = typeof body !== "string" ? JSON.stringify(body) : body;
  }

  const requestConfig = { method, ...params };
  return fetch(url, requestConfig);
}

// This function processes the raw response based on its content type
async function processResponse(response) {
  let jsonResponse;
  let textResponse;
  let blobResponse;
  let fileName = "";

  const { status, headers } = response;

  if (status === 200) {
    const contentType = headers.get("Content-Type");

    if (contentType === "application/octet-stream") {
      fileName = headers.get("content-disposition");
      blobResponse = await response.blob();
      return { blobResponse, fileName };
    }
    textResponse = await response.text();
    try {
      jsonResponse = JSON.parse(textResponse);
    } catch (error) {
      jsonResponse = textResponse;
    }
    return jsonResponse;
  }

  textResponse = await response.json();
  return Promise.reject(textResponse);
}

// This function combines makeRawRequest and processResponse
async function makeRequest(url, method, body, auth, header) {
  const response = await makeRawRequest(url, method, body, auth, header);
  return processResponse(response);
}

const makeAjaxRequest = {
  fetchWithAuth: url => makeRequest(url, "GET", false, true),
  postWithAuth: (url, body) => makeRequest(url, "POST", body, true),
  putWithAuth: (url, body) => makeRequest(url, "PUT", body, true),
  deleteWithAuth: url => makeRequest(url, "DELETE", false, true),
  fetch: (url, header) => makeRequest(url, "GET", false, false, header),
  post: (url, body) => makeRequest(url, "POST", body, false),
  put: (url, body) => makeRequest(url, "PUT", body, false)
};

export default makeAjaxRequest;

export function makeAjaxRequestBase({ url, method, body }) {
  if (method === "GET") {
    return makeRawRequest(url, "GET", false, true);
  } else if (method === "POST") {
    return makeRawRequest(url, "POST", body, true);
  } else if (method === "PUT") {
    return makeRawRequest(url, "PUT", body, true);
  }
}
